export class DataPage {
    public result: any[];
    public pages: number;
    public total: number;
    public pageNum:number;
    public pageSize: number;
    public startRow: number;
    public endRow:number;
}
